import { StoreState } from '../../types';
import { ShortcutsModalReducerState } from './types';

const getState = (state: StoreState): ShortcutsModalReducerState => state.shortcutsModal;

export const getIsOpened = (state: StoreState) => getState(state).isOpen;
